<template>
  <v-dialog v-model="showDialog" persistent max-width="480">
    <v-card class="pa-3" width="480">
      <v-card-title class="headline">
        Seleccionar Tipo de Base de Trabajo
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="workTypeSelected">
          <v-radio
            color="#C46D24"
            v-for="(workType, index) in optionsWork"
            :key="index"
            :label="workType"
            :value="index"
          ></v-radio>
        </v-radio-group>
        <p v-if="workTypeSelected === 2">
          Debido a que el típo de base de trabajo seleccionada es
          <strong>Híbrido</strong>, debe indicar explícitamente en el calendario
          los días que son de
          <strong>Base de Trabajo Remoto XR.</strong>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="text-capitalize"
          color="red darken-1"
          dark
          depressed
          @click="cancel"
        >
          <font-awesome-icon
            class="mr-2"
            size="lg"
            :style="{ color: '#FFFFFF' }"
            :icon="['fal', 'times-circle']"
          />
          Cancelar
        </v-btn>

        <v-btn
          v-if="workTypeSelected !== 2"
          class="text-capitalize"
          color="#466EA5"
          depressed
          :dark="workTypeSelected !== null"
          :disabled="workTypeSelected === null"
          @click="accept"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'clipboard-list-check']"
          />
          Agregar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CheckNormalMonth",
  data() {
    return {
      optionsWork: [
        "X - Base de Trabajo",
        "XR - Base de Trabajo Remoto",
        "X + XR - Híbrido"
      ],
      workTypeSelected: null,
      showDialog: true
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    accept() {
      if (this.workTypeSelected === 2) return;
      this.$emit("accept", this.workTypeSelected);
      this.cancel();
    },
    showSendBtn() {
      let result = this.optionsWork !== 2;
      console.log("showSendBtn", result);
      return result;
    }
  }
};
</script>

<style lang="scss" scoped></style>
